<template>
    <div class="station_core_waybills x_scrollable">
        <h1 class="ui header">
            <!-- 訂單內待處理運單 -->
            {{ $t('ui.pages.monitor.title.pending_waybill_in_operations') }}
            <div class="sub header"
                v-html="$t('ui.pages.monitor.sub_title.assigned_to_stationg_but_not_completed_waybill_in_operations', {
                    station_name: current_station.name
                })"
            >
                <!--
                    分配給
                    <span style="color: green">{{ current_station.name }}</span>
                    處理的訂單中未完成的運單
                -->
            </div>
        </h1>
        <table class="ui compact celled table">
            <thead class="center aligned">
                <tr>
                    <!--
                        <th>訂單號</th>
                        <th>物料</th>
                        <th>單號</th>
                        <th>收件人電話</th>
                        <th>收件人姓名</th>
                        <th>重量</th>
                        <th>代收貨款</th>
                        <th>貨況</th>
                    -->
                    <th>{{ $t("models.attributes.core_waybills.operation_number") }}</th>
                    <th>{{ $t('models.materials') }}</th>
                    <th>{{ $t("models.attributes.core_waybills.number") }}</th>
                    <th>{{ $t("models.attributes.core_waybills.consignee_phone") }}</th>
                    <th>{{ $t("models.attributes.core_waybills.consignee_name") }}</th>
                    <th>{{ $t("models.attributes.core_waybills.weight_in_kilo") }}</th>
                    <th>{{ $t("models.attributes.core_waybills.collection") }}</th>
                    <th>{{ $t("models.attributes.core_waybills.latest_status") }}</th>
                    <th class="center aligned">
                        <div class="ui basic icon button" @click="show_filter = !show_filter">
                            <i class="angle double up icon" v-if="show_filter"></i>
                            <i class="angle double down icon" v-else></i>
                        </div>
                    </th>
                </tr>
                <tr class="center aligned" v-show="show_filter">
                    <th>
                        <div class="ui mini input">
                          <input type="text" v-model="search_params.operation.number" @keyup.enter="fetch_core_waybills">
                        </div>
                    </th>
                    <th>
                        <select v-dropdown v-model="search_params.material.class_names" ref="material_selector">
                            <option value>{{ $t('ui.general.please_select') }}</option>
                            <option v-for="material in materials" :value="material.class_name">{{ material.name }}</option>
                        </select>
                    </th>
                    <th>
                        <div class="ui mini input">
                          <input type="text" v-model="search_params.number" @keyup.enter="fetch_core_waybills">
                        </div>
                    </th>
                    <th>
                        <div class="ui mini input">
                          <input type="text" v-model="search_params.consignee_phone" @keyup.enter="fetch_core_waybills">
                        </div>
                    </th>
                    <th>
                        <div class="ui mini input">
                          <input type="text" v-model="search_params.consignee_name" @keyup.enter="fetch_core_waybills">
                        </div>
                    </th>
                    <th></th>
                    <th>
                        <div class="ui mini input">
                          <input type="number" v-model="search_params.weight_in_kilo" @keyup.enter="fetch_core_waybills">
                        </div>
                    </th>
                    <th>
                        <div class="ui mini input">
                          <input type="number" v-model="search_params.collection" @keyup.enter="fetch_core_waybills">
                        </div>
                    </th>
                    <th>
                        <div class="ui icon mini buttons">
                            <div class="ui black basic button" @click.prevent="fetch_core_waybills">
                                <i class="search icon"></i>
                            </div>
                            <div class="ui black basic button" @click.prevent="init_search_params">
                                <i class="refresh icon"></i>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="show_core_waybills">
                <CoreWaybill
                    v-for="core_waybill in core_waybills"
                    :key="core_waybill.identity"
                    :core_waybill="core_waybill"
                    :is_processing="is_processing"
                ></CoreWaybill>
                <tr v-if="core_waybills.length <= 0" class="center aligned">
                    <td colspan="8" >
                        <h5>{{ $t('ui.general.no_data') }}</h5>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr class="loading">
                    <td colspan="8">
                        <div class="ui active centered inline loader"></div>
                    </td>
                </tr>
            </tbody>
        </table>

        <Paginator
            v-if="core_waybills.length > 0"
            :total_pages="pagination.total_pages"
            :current_page="pagination.current_page"
            change_page_channel="personal_core_waybills_under_operations"
        />
    </div>
</template>

<script>
import CoreWaybill from "./item.vue"
import Paginator from '@toolbox/pagination/paginator.vue'

export default {
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            show_core_waybills: false,
            show_filter: false,
            core_waybills: [],
            materials: [],
            pagination: {},
            search_params: {
                operation: {
                    number: null,
                    is_done: false,
                    is_canceled: false,
                    station_identity: null,
                    // under_processing: true,
                },
                material: {
                    class_names: null,
                },
                number: null,
                consignee_phone: null,
                consignee_name: null,
                weight_in_kilo: null,
                collection: null,
                // latest_status_scope: "operator",
                is_done: false,
            },
            errors: [],
        }
    },
    computed: {
        current_station() {
            return this.$store.state.provider.current_staff.station
        },
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.search_params.operation_station_identity = this.current_station.identity
                resolve()
            })
            await this.fetch_materials()
            await this.fetch_core_waybills()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })

            // pagination channel
            this.$bus.$off('personal_core_waybills_under_operations')
            this.$bus.$on('personal_core_waybills_under_operations', (page) => {
                this.$store.state.provider.core_waybills_module.current_page = page
                this.search_params.page = page
                this.fetch_core_waybills()
            })
        },
        fetch_materials() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_materials).parse(
                {},
                ""
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.materials = response.data.materials
                    } else if (response.data.status == "failure") {
                        this.errors = response.data.errors
                        // this.$noty.error("抓取物料失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.materials'),
                                reason: ': ' + response.data.errors
                            })
                        )
                    }
                    return response
                })
                .catch(error => {
                    console.log('Failed to fetch materials.')
                    return Promise.reject(error)
                })
        },
        fetch_core_waybills() {
            var filter = _.cloneDeep(this.search_params)

            // where_like add %% staring
            _.forEach([
                "number",
                "flight_number",
                "original_number",
                "tracking_number",
                "sender_name",
                "consignee_name",
                "consignee_address",
                "consignee_phone",
                "note"
            ], name => {
                if (filter[name]) {
                    filter[name] = "%"+filter[name]+"%"
                }
            })

            if (filter.operation.number) {
                filter.operation.number = "%"+filter.operation.number+"%"
            }

            if (this.is_processing == false) {
                this.show_core_waybills = false
                this.is_processing = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills_filter).parse(
                    {},
                    "?" + object_to_query(filter)
                )
                return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.core_waybills = response.data.core_waybills
                        this.pagination = response.data.pagination
                    } else if (response.data.status == "failure") {
                        this.errors = response.data.errors
                        // this.$noty.error("抓取訂單失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.core_waybills'),
                                reason: ': ' + response.data.errors
                            })
                        )
                    }
                    return response
                })
                .catch(error => {
                    // this.errors.push("抓取訂單失敗" + this.$t('ui.general.network_abnormality')+": "+ error.response.status)
                    this.errors.push(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.core_waybills'),
                            reason: ': ' +this.$t('ui.general.network_abnormality')+','+ error.response.status
                        })
                    )

                    return Promise.reject(error)
                })
                .then(() => {
                    setTimeout(() => {
                        this.is_processing = false
                        this.show_core_waybills = true
                    }, 300)
                })
            }
        },
        init_search_params() {
            this.search_params = {
                operation: {
                    number: null,
                    is_done: false,
                    is_canceled: false,
                    station_identity: this.current_station.identity,
                    // under_processing: true,
                },
                material: {
                    class_names: null,
                },
                number: null,
                consignee_phone: null,
                consignee_name: null,
                weight_in_kilo: null,
                collection: null,
                // latest_status_scope: "operator",
                is_done: false,
            }
            $(".station_core_waybills .ui.dropdown").dropdown('clear')
        },
    },
    components: {
        CoreWaybill,
        Paginator,
    }
}
</script>
<style scoped>
</style>
